import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserInfoModel } from "services/sale/common/types";
import { MarketPlace_GetBasicConfig_Response } from "services/sale/marketPlace/types";
import { MessageItem } from "shared/marketPlace/fleet/components/messages/components/msgMenu/types";
import { MessageFilterType_Enum } from "shared/marketPlace/fleet/components/messages/enums";
import { GetInboxMessage_Response } from "shared/marketPlace/fleet/components/messages/types";

interface LoginMethod {
  usernamePassword_Login: boolean;
  otP_Login: boolean;
}
interface UserModel {
  usernamePassword_Login: boolean;
  otP_Login: boolean;
  userData?: MarketPlace_GetBasicConfig_Response | null;
  fromMarketPlace?: boolean;
  allowGetTripForOthers: boolean;
  // دریافت کد ملی مسافرین در سفر برون شهری در واحد
  getPassengerNationalNoInOutCityTrip: boolean;
  // دریافت کد ملی مسافرین در سفر درون شهری در واحد
  getPassengerNationalNoInInCityTrip: boolean;
  // توضیحات فرم ثبت کد ملی مسافرین
  insertPassengerNationalNoFormDescription: string;
  // توضیحات فرم ثبت سفر برای دیگری
  getTripForOthersFormDescription: string;
  tripDispatchInterval?: number;
  // راهنمای pickup
  pickupHelp: string;

  // مربوط به پیام ها
  msgSelectCount?: number;
  totalData: GetInboxMessage_Response[];
  msgSelect?: GetInboxMessage_Response;
  menuList: MessageItem[];
  msgGetLoading: boolean;
}

const initialState: UserModel = {
  usernamePassword_Login: false,
  otP_Login: false,
  userData: null,
  fromMarketPlace: undefined,
  allowGetTripForOthers: false,
  getPassengerNationalNoInOutCityTrip: false,
  getPassengerNationalNoInInCityTrip: false,
  insertPassengerNationalNoFormDescription: null!,
  getTripForOthersFormDescription: null!,
  tripDispatchInterval: undefined,
  pickupHelp: null!,
  msgSelectCount: undefined!,
  totalData: [],
  msgSelect: undefined,
  msgGetLoading: false,
  menuList: [
    {
      type: MessageFilterType_Enum.Inbox,
      text: "دریافتی",
      count: undefined,
    },
    {
      type: MessageFilterType_Enum.Sent,
      text: "ارسالی",
      count: undefined,
    },
    {
      type: MessageFilterType_Enum.Notify,
      text: "اعلان ها",
      count: undefined,
    },
  ],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    //اپدیت داده ها
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
    closeMsgMenu: (state) => {
      state.menuList = [
        {
          type: MessageFilterType_Enum.Inbox,
          text: "دریافتی",
          count: undefined,
        },
        {
          type: MessageFilterType_Enum.Sent,
          text: "ارسالی",
          count: undefined,
        },
        {
          type: MessageFilterType_Enum.Notify,
          text: "اعلان ها",
          count: undefined,
        },
      ];
      state.msgSelectCount = undefined!;
      state.totalData = [];
      state.msgSelect = undefined;
      state.msgGetLoading = false;
      return state;
    },
    updateUserData: (
      state,
      action: PayloadAction<MarketPlace_GetBasicConfig_Response>
    ) => {
      state.userData = action.payload;
      return state;
    },
    updateLoginMethod: (state, action: PayloadAction<LoginMethod>) => {
      state.otP_Login = action.payload.otP_Login;
      state.usernamePassword_Login = action.payload.usernamePassword_Login;
      return state;
    },
    updateCurrentTripStatus: (state, action) => {
      state.userData &&
        (state.userData.tripInfo.hasCurrentTrip =
          action.payload.hasCurrentTrip);
    },
    updateBalance: (state, action: PayloadAction<number>) => {
      if (state?.userData?.walletInfo?.ballance)
        state.userData.walletInfo.ballance = action.payload;
      return state;
    },
    updateUserInfo: (state, action: PayloadAction<UserInfoModel>) => {
      if (state?.userData) state.userData.userInfo = action.payload;
      return state;
    },
  },
});

export default userSlice;
